import * as React from 'react';
import { CustomSubmitButton, CustomButton, ButtonType, Modal, ModalBody, ModalFooter, ModalSize, AlertMessage, AlertType, CustomDatePicker, HiddenInput, Form, Select } from 'soprasteria-ui-library';
import { useAuth } from '../../../../App';
import { ISaveOrthondonticReferralTreatment } from '../../../../models/IOrthodonticReferral';
import { OrthodonticReferralTreatmentApi } from '../../../../api/OrthodonticReferralTreatmentApi';
import { TreatmentsDropdown } from '../../TreatmentReport/TreatmentsDropdown';
import { IPatientTreatment } from '../../../../models/IPatientTreatment';
import { setMessage } from '../../../../helpers/MessageHelper';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { CarePerformerApi } from '../../../../api/CarePerformerApi';
import { formatDate } from '../../../../helpers/DateHelper';
import { ORTHODONTIC_SPECIALITYID } from '../../../../utils/SpecialityConstants';
import { OrthodonticReferralApi } from '../../../../api/OrthodonticReferralApi';
import { INVANTAR_INTERCEPTIV_APPARATUR_STATUSID, UNDER_BEHANDLING_STATUSID } from '../../../../utils/OrthodonticReferralConstants';
import { ICarePerformer } from '../../../../models/ICarePerformer';

interface IOrthodonticReferralTreatmentModal {
    getOrthodonticReferral: (orthodonticReferralId: number, refresh: boolean) => void;
    orthodonticReferralId: number;
    orthodonticReferralStatusId: number;
    minimumTreatmentDate?: Date;
    changeSuccessMessage: (message: string) => void;
    renderForm: boolean;
    setRenderForm: React.Dispatch<React.SetStateAction<boolean>>;
    hasRoleAllmantandvard: boolean;
    hasRoleOrtodontisttandvård: boolean;
    referralClosedDate?: Date;
}

export const OrthodonticReferralTreatmentModal: React.FunctionComponent<IOrthodonticReferralTreatmentModal> = ({ getOrthodonticReferral, orthodonticReferralId, orthodonticReferralStatusId, minimumTreatmentDate, changeSuccessMessage, setRenderForm, renderForm, hasRoleAllmantandvard, hasRoleOrtodontisttandvård, referralClosedDate }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralTreatmentApi(auth);
    const orthodonticApi = new OrthodonticReferralApi(auth);
    const carePerformerApi = new CarePerformerApi(auth);
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [noCarePerformersMessage, setNoCarePerformersMessage] = React.useState<string>();
    const [treatmentCodes, setTreatmentCodes] = React.useState<IPatientTreatment[]>();
    const [isSavingTreatment, setIsSavingTreatment] = React.useState<boolean>();
    const [carePerformers, setCarePerformers] = React.useState<IListItem[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [date, setDate] = React.useState<Date>(new Date());

    React.useEffect(() => {

        loadCarePerformerDentists();
    }, [date])

    const loadCarePerformerDentists = () => {
        if ((orthodonticReferralStatusId === INVANTAR_INTERCEPTIV_APPARATUR_STATUSID || orthodonticReferralStatusId === UNDER_BEHANDLING_STATUSID && hasRoleAllmantandvard) && hasRoleAllmantandvard) {
            carePerformerApi.getCarePerformerDentistsWithDate(formatDate(date), (carePerformersData) => {
                setCarePerformersFromApi(carePerformersData);
            }, undefined, () => setIsLoading(false));
        } else {
            carePerformerApi.getCarePerformerDentistsWithDateAndSpeciality(formatDate(date), ORTHODONTIC_SPECIALITYID, (carePerformersData) => {
                setCarePerformersFromApi(carePerformersData);
            }, undefined, () => setIsLoading(false));
        }
    }

    const setCarePerformersFromApi = (carePerformersData: ICarePerformer[]) => {
        let mappedCarePerformers = carePerformersData.map<IListItem>((carePerformer) => { return { text: carePerformer.carePerformerName, value: carePerformer.carePerformerId.toString() } });
        setCarePerformers(mappedCarePerformers);
        if (mappedCarePerformers.length === 0) {
            const newMessage = setMessage("Det finns ingen registrerad behandlare för mottagningen på angivet behandlingsdatum. Ansök om ny behandlare, alternativt om behandlaren är registrerad på annan mottagning, lägg till behandlaren på mottagningen.", noCarePerformersMessage ?? "");
            setNoCarePerformersMessage(newMessage);
        } else {
            setNoCarePerformersMessage("");
            getTreatmentCodes();
        }
    }

    const getTreatmentCodes = () => {
        api.getAvailableTreatmentCodes(orthodonticReferralId, (newTreatmentCodes) => setTreatmentCodes(newTreatmentCodes));
    }

    const saveTreatmentCode = (data: ISaveOrthondonticReferralTreatment) => {
        if (hasRoleOrtodontisttandvård) {
            setIsSavingTreatment(true);
            api.saveOrthodonticReferralOrthodonticCheckTreatment(data, () => {
                document.getElementById("close-add-orthodontic-referral-treatment-modal")?.click();
                changeSuccessMessage("Åtgärdskoden har lagts till");
                getOrthodonticReferral(orthodonticReferralId, true);
                setRenderForm(false);
            }, (error) => setErrorMessage(setMessage(error, errorMessage ?? ""))
                , () => setIsSavingTreatment(false));
        }
        else if (hasRoleAllmantandvard) {
            setIsSavingTreatment(true);
            api.saveOrthodonticReferralInterceptiveCheckTreatment(data, () => {
                document.getElementById("close-add-orthodontic-referral-treatment-modal")?.click();
                changeSuccessMessage("Åtgärdskoden har lagts till");
                getOrthodonticReferral(orthodonticReferralId, true);
                setRenderForm(false);
            }, (error) => setErrorMessage(setMessage(error, errorMessage ?? ""))
                , () => setIsSavingTreatment(false));
        }
    }
    const onTreatmentDateChange = (treatmentDate: Date | null) => {
        if (treatmentDate === null) {
            setDate(new Date());
        } else {
            setDate(treatmentDate);
        }
    }
    const setMinimumTreatmentDate = () => {
        if (minimumTreatmentDate) {
            var currentDate = new Date();
            var minDate = new Date(currentDate);
            minDate.setDate(minDate.getDate() - 90);

            const recievedDateAsDate = new Date(minimumTreatmentDate);

            return minDate < recievedDateAsDate
                ? recievedDateAsDate
                : minDate;
        }
    }

    return (
        <Modal id="add-orthodontic-referral-treatment-modal" header="Lägg till åtgärdskod" modalSize={ModalSize.large}>
            {
                renderForm ?
                    <Form onSubmit={saveTreatmentCode}>
                        <ModalBody>
                            <HiddenInput name="orthodonticReferralId" value={orthodonticReferralId.toString()} />
                            <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                            <AlertMessage alertType={AlertType.danger} duration={10000}>{noCarePerformersMessage}</AlertMessage>
                            <CustomDatePicker name="treatmentDate"
                                label="Behandlingsdatum"
                                tooltipDescription="Avser datumet när behandlingsåtgärden utfördes på patienten, ska överensstämma med journalen"
                                onChange={onTreatmentDateChange}
                                min={setMinimumTreatmentDate()}
                                max={referralClosedDate ? new Date(referralClosedDate) : new Date()}
                                required
                                inlineLabel />
                            <Select name="carePerformerId"
                                label="Behandlare"
                                placeholder="Välj en behandlare"
                                options={carePerformers}
                                isLoading={isLoading}
                                inlineLabel
                                required />
                            {
                                treatmentCodes ?
                                    <div>
                                        <TreatmentsDropdown label="Åtgärdskod" treatments={treatmentCodes ?? []} isLoading={treatmentCodes === undefined} name="treatmentCodeId" />
                                    </div>
                                    : null
                            }

                        </ModalBody>
                        <ModalFooter>
                            <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-add-orthodontic-referral-treatment-modal" onClick={() => { setRenderForm(false); setErrorMessage(undefined); }} />
                            <CustomSubmitButton isLoading={isSavingTreatment}>Spara</CustomSubmitButton>
                        </ModalFooter>
                    </Form>
                    : null
            }
        </Modal>
    )
}